import { theme as baseTheme } from "@eai-toolkit-material-ui/theme";
import { createTheme } from "@mui/material/styles";

// Override to use the old breakpoint values: https://v5.mui.com/material-ui/migration/v5-component-changes/#breakpoint-sizes
const theme = createTheme({
  ...baseTheme,
  breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } },
});
theme.typography.h1 = { ...theme.typography.h1, fontSize: "1.875rem" };
theme.typography.h4 = { ...theme.typography.h4, fontSize: "1rem" };

export default theme;
